import { Link } from "react-router-dom";

import { makeStyles } from "@material-ui/core/styles";
import { Card, CardContent, Container } from "@material-ui/core";

import KeyboardBackspaceIcon from "@material-ui/icons/KeyboardBackspace";

import Scrollbar from "components/Scrollbar/Scrollbar";
import componentStyles from "assets/theme/views/auth/login";
import { TermsOfUseCmp } from "variables/termsOfUse";

const useStyles = makeStyles(componentStyles);

export default function TermsOfUse() {
  const classes = useStyles();

  return (
    <>
      {alert}
      <Container
        maxWidth="md"
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}
      >
        <Card classes={{ root: classes.card }}>
          <Link className={classes.back} to={"login"}>
            <KeyboardBackspaceIcon /> Voltar
          </Link>

          <CardContent classes={{ root: classes.cardContent }}>
            <Scrollbar
              style={{
                maxHeight: 400,
                paddingRight: "1.5rem",
              }}
            >
              <TermsOfUseCmp color="white" />
            </Scrollbar>
          </CardContent>
        </Card>
      </Container>
    </>
  );
}
